import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HomeComponent} from './home/home.component';
import {AccordionModule} from 'primeng/accordion';
import {PanelModule} from 'primeng/panel';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RadioButtonModule} from 'primeng/radiobutton';
import {ButtonModule} from 'primeng/button';
import {NewsComponent} from './news/news.component';
import {TrendingComponent} from './news/trending/trending.component';
import {ServiceModule} from './service/service.module';
import {MessagesModule} from 'primeng/messages';
import {AppCommonModule} from './common/common.module';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {InputTextModule} from 'primeng/inputtext';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {CardModule} from 'primeng/card';
import {RouterModule} from '@angular/router';
import {SelectButtonModule} from 'primeng/selectbutton';
import {CommonNewsComponent} from './common/news/news.component';
import {ContactUsComponent} from './contact-us/contact-us.component';
import {CommonMapComponent} from './common/map/map.component';
import {PlatformComponent} from './platform/platform.component';
import {LoginComponent} from './login/login.component';
import {LoginFormComponent} from './login/form/login-form.component';
import {DropdownModule} from 'primeng/dropdown';
import {AuthenticationManager, AuthenticationNotificationService, ProgressIndicatorService} from './@shared';
import {SecureModule} from './secure/secure.module';
import {CommonModule, DecimalPipe, NgForOf, NgIf, NgOptimizedImage} from '@angular/common';
import {ProductService} from './service/product.service';
import {MessageService, SharedModule} from 'primeng/api';
import {TableModule} from 'primeng/table';
import {DividerModule} from 'primeng/divider';
import {NewProductComponent} from './secure/products/new-product/new-product.component';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {InputNumberModule} from 'primeng/inputnumber';
import {TabViewModule} from 'primeng/tabview';
import {InplaceModule} from 'primeng/inplace';
import {MaintainProductComponent} from './secure/products/maintain-product/maintain-product.component';
import {UpdateProductComponent} from './secure/products/update-product/update-product.component';
import {ToastModule} from 'primeng/toast';
import {AngularEditorModule} from '@kolkov/angular-editor';
import {TooltipModule} from 'primeng/tooltip';
import {FieldsetModule} from 'primeng/fieldset';
import {PasswordModule} from 'primeng/password';
import {CheckboxModule} from 'primeng/checkbox';
import {BlockUIModule} from 'primeng/blockui';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {RETRY_PROVIDER} from './@shared/http.retry-interceptor';
import {BrowserModule} from '@angular/platform-browser';
import {GalleriaModule} from 'primeng/galleria';
import {ProgressBarModule} from 'primeng/progressbar';
import {LayoutModule} from '@angular/cdk/layout';
import {NotFoundComponent} from './not-found/not-found.component';
import {RedirectComponent} from './redirect/redirect.component';
import {PreviousRouteService} from './@shared/previous-route.service';
import {NavBarComponent} from './navigation/v3.0/navbar.component';
import {RfqComponent} from './rfq/rfq.component';
import {CarouselModule} from 'primeng/carousel';
import {SliderModule} from 'primeng/slider';
import {SliderComponent} from './@shared/slider/slider.component';
import {StepOneComponent} from './rfq/step-one/step-one.component';
import {RfqDataService} from './rfq/service/rfq.data.service';
import {SidebarComponent} from './rfq/sidebar/sidebar.component';
import {StepTwoComponent} from './rfq/step-two/step-two.component';
import {StepThreeComponent} from './rfq/step-three/step-three.component';
import {StepFourComponent} from './rfq/step-four/step-four.component';
import {AboutUsComponent} from './about-us/about-us.component';
import {ResidentialSolarComponent} from './residential-solar/residential-solar.component';
import {LearnAboutSolarComponent} from './residential-solar/learn-about-solar/learn-about-solar.component';
import {
    SizesOfSolarPvSystemsComponent
} from './residential-solar/sizes-of-solar-pv-systems/sizes-of-solar-pv-systems.component';
import {BaseComponent} from './common/component/base/base.component';
import {JourneyComponent} from './journey/journey.component';
import {
    BenefitsOfSolarEnergyComponent
} from './residential-solar/benefits-of-solar-energy/benefits-of-solar-energy.component';
import {AboutSolarBatteriesComponent} from './residential-solar/about-solar-batteries/about-solar-batteries.component';
import {
    HowToChooseASolarInstallerComponent
} from './residential-solar/how-to-choose-a-solar-installer/how-to-choose-a-solar-installer.component';
import {
    SiteAssessmentExpectationsComponent
} from './residential-solar/site-assessment-expectations/site-assessment-expectations.component';
import {
    InstallationTimelinesComponent
} from './residential-solar/installation-timelines/installation-timelines.component';
import {
    MaintainingYourSolarPanelsComponent
} from './residential-solar/maintaining-your-solar-panels/maintaining-your-solar-panels.component';
import {
    MonitoringYourSystemComponent
} from './residential-solar/monitoring-your-system/monitoring-your-system.component';
import {
    MaximisingSavingsWithSolarComponent
} from './residential-solar/maximising-savings-with-solar/maximising-savings-with-solar.component';
import {
    YourUtilityBillAfterSolarComponent
} from './residential-solar/your-utility-bill-after-solar/your-utility-bill-after-solar.component';
import {
    UpgradingYourSolarSystemComponent
} from './residential-solar/upgrading-your-solar-system/upgrading-your-solar-system.component';
import {InvertersComponent} from './retail/inverters/inverters.component';
import {ProductComponent} from './retail/product/product.component';
import {ReadonlyDirective} from './common/directive/readonly.directive';
import {RatingModule} from 'primeng/rating';
import {RetailComponent} from './retail/retail.component';
import {BatteriesComponent} from './retail/batteries/batteries.component';
import {PVPanelsComponent} from './retail/pv-panels/pv-panels.component';
import {MountingStructuresComponent} from './retail/mounting-structures/mounting-structures.component';
import {SunsynkComponent} from './retail/brands/sunsynk/sunsynk.component';
import {VictronComponent} from './retail/brands/victron/victron.component';
import {GrowattComponent} from './retail/brands/growatt/growatt.component';
import {CanadianSolarComponent} from './retail/brands/canadian-solar/canadian-solar.component';
import {JaSolarComponent} from './retail/brands/ja-solar/ja-solar.component';
import {GrowcolComponent} from './retail/brands/growcol/growcol.component';
import {TheNextElectricityCrisisComponent} from './news/trending/2024-06-20/the-next-electricity-crisis.component';
import {NewsListComponent} from './news/list/news-list.component';
import {
    PrivateSolarIsHelpingToKeepTheLightsOn
} from './news/trending/2024-04-15/private-solar-is-helping-to-keep-the-lights-on';
import {
    HowToMaximiseSolarPanelPerformanceInWinter
} from './news/trending/2024-06-01/how-to-maximise-solar-panel-performance-in-winter';
import {
    BigSlowdownInSolarInstallationsInSouthAfrica
} from './news/trending/2024-07-03/big-slowdown-in-solar-installations-in-south-africa';
import {NewsTrendingTemplateComponent} from './news/trending/template/news-trending-template.component';
import {
    WhatYouShouldKnowBeforeInstallingSolarPanelsAndBatteriesComponent
} from './news/trending/2022-07-08/what-you-should-know-before-installing-solar-panels-and-batteries.component';
import {
    GoodNewsForSolarInSouthAfricaComponent
} from './news/trending/2022-07-25/good-news-for-solar-in-south-africa.component';
import {SolarEnergyComponent} from './news/trending/2022-09-12/solar-energy.component';
import {ImagePreloadService} from './service/image-preload.service';
import {QuoteViewComponent} from './retail/quote-view/quote-view.component';
import {VoltaComponent} from './retail/brands/volta/volta.component';
import {LongiComponent} from './retail/brands/longi/longi.component';
import {DeyeComponent} from './retail/brands/deye/deye.component';
import {TermsOfSaleComponent} from './retail/terms-of-sale/terms-of-sale.component';
import {BeyondEskomsLatestIncrease} from './news/trending/2025-08-01/beyond-eskoms-latest-increase';

@NgModule({
    declarations: [
        AboutUsComponent,
        AppComponent,
        CommonNewsComponent,
        ContactUsComponent,
        HomeComponent,
        NewsComponent,
        TrendingComponent,
        NewsTrendingTemplateComponent,
        NewsListComponent,
        BeyondEskomsLatestIncrease,
        TheNextElectricityCrisisComponent,
        HowToMaximiseSolarPanelPerformanceInWinter,
        GoodNewsForSolarInSouthAfricaComponent,
        PrivateSolarIsHelpingToKeepTheLightsOn,
        BigSlowdownInSolarInstallationsInSouthAfrica,
        WhatYouShouldKnowBeforeInstallingSolarPanelsAndBatteriesComponent,
        SolarEnergyComponent,
        PlatformComponent,
        LoginComponent,
        LoginFormComponent,
        NewProductComponent,
        MaintainProductComponent,
        UpdateProductComponent,
        NavBarComponent,
        RedirectComponent,
        NotFoundComponent,
        RfqComponent,
        StepOneComponent,
        StepTwoComponent,
        StepThreeComponent,
        StepFourComponent,
        SidebarComponent,
        SliderComponent,
        BaseComponent,
        ResidentialSolarComponent,
        LearnAboutSolarComponent,
        SizesOfSolarPvSystemsComponent,
        JourneyComponent,
        BenefitsOfSolarEnergyComponent,
        AboutSolarBatteriesComponent,
        HowToChooseASolarInstallerComponent,
        SiteAssessmentExpectationsComponent,
        InstallationTimelinesComponent,
        MaintainingYourSolarPanelsComponent,
        MonitoringYourSystemComponent,
        MaximisingSavingsWithSolarComponent,
        YourUtilityBillAfterSolarComponent,
        UpgradingYourSolarSystemComponent,
        BatteriesComponent,
        DeyeComponent,
        InvertersComponent,
        MountingStructuresComponent,
        PVPanelsComponent,
        SunsynkComponent,
        VictronComponent,
        VoltaComponent,
        GrowattComponent,
        CanadianSolarComponent,
        JaSolarComponent,
        LongiComponent,
        GrowcolComponent,
        ProductComponent,
        ReadonlyDirective,
        RetailComponent,
        QuoteViewComponent,
        TermsOfSaleComponent
    ],
    imports: [
        AppCommonModule,
        AppRoutingModule,
        AccordionModule,
        BlockUIModule,
        BrowserAnimationsModule,
        BrowserModule.withServerTransition({appId: 'serverApp'}),
        GalleriaModule,
        ButtonModule,
        CarouselModule,
        CommonModule,
        CardModule,
        FormsModule,
        HttpClientModule,
        PanelModule,
        RadioButtonModule,
        ReactiveFormsModule,
        RouterModule,
        ServiceModule.forRoot(),
        MessagesModule,
        InputTextareaModule,
        InputTextModule,
        SelectButtonModule,
        DropdownModule,
        SecureModule,
        TableModule,
        DividerModule,
        BreadcrumbModule,
        InputNumberModule,
        TabViewModule,
        InplaceModule,
        InputTextareaModule,
        ReactiveFormsModule,
        ToastModule,
        AngularEditorModule,
        TooltipModule,
        FieldsetModule,
        PasswordModule,
        CheckboxModule,
        BlockUIModule,
        ProgressSpinnerModule,
        FormsModule,
        InputTextModule,
        ProgressBarModule,
        LayoutModule,
        NgOptimizedImage,
        CommonModule,
        NgIf,
        RouterModule,
        RouterModule,
        NgIf,
        RouterModule,
        SliderModule,
        BreadcrumbModule,
        ButtonModule,
        DecimalPipe,
        DividerModule,
        GalleriaModule,
        NgForOf,
        NgIf,
        SharedModule,
        TabViewModule,
        TableModule,
        ButtonModule,
        InputNumberModule,
        RatingModule
    ],
    providers: [
        HttpClient,
        ProductService,
        MessageService,
        AuthenticationManager,
        ProgressIndicatorService,
        AuthenticationNotificationService,
        PreviousRouteService,
        RfqDataService,
        ImagePreloadService
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [
        CommonMapComponent
    ]
})
export class AppModule {
}
